module.exports = "http://cdn.realive.com.ua/src/views/player/help/images/heli1.jpg";